import React from "react";
import { Button, Typography, Grid, Backdrop, Card, Slide, Box } from "@mui/material";

const GeneralConfirmation = ({ show, title, handleClose, handleSuccess, agreeText, declinedText, subtitle }) => {
	const handleCardClick = (event) => {
		event.stopPropagation();
	};

	return (
		<Backdrop open={show} onClick={handleClose} sx={{ zIndex: 1301 }}>
			<Box sx={{ zIndex: 1302 }}>
				<Slide direction="left" in={show} mountOnEnter unmountOnExit>
					<Card sx={{ width: "500px", paddingY: "20px", borderRadius: "8px", backgroundColor: "#FFFEFE" }} onClick={handleCardClick}>
						<Grid
							container
							sx={{
								display: "flex",
								justifyContent: "center",
							}}
						>
							<Grid item xs={12}>
								<Typography id="text-alert-title" sx={{ textAlign: "center", fontSize: "18px", marginBottom: "20px" }}>
									{title}
								</Typography>
							</Grid>
							<Grid item xs={12}>
								<Typography id="text-alert-subtitle" sx={{ textAlign: "center", fontSize: "18px", marginBottom: "20px" }}>
									{subtitle}
								</Typography>
							</Grid>
							<Grid item xs={6} sx={{ display: "flex", justifyContent: "center", columnGap: "15px", px: "20px" }}>
								<Button
									id="button-style-save-reception-form"
									type="submit"
									variant="contained"
									color={"error"}
									sx={{ width: "100%" }}
									onClick={handleSuccess}
								>
									{agreeText}
								</Button>
							</Grid>
							<Grid item xs={6} sx={{ display: "flex", justifyContent: "center", columnGap: "15px", px: "20px" }}>
								<Button
									id="button-style-save-reception-form"
									type="submit"
									variant="contained"
									color="secondary"
									sx={{ width: "100%" }}
									onClick={handleClose}>
									{declinedText}
								</Button>
							</Grid>
						</Grid>
					</Card>
				</Slide>
			</Box>
		</Backdrop>
	);
};

export default GeneralConfirmation;